export default __webpack_public_path__ + "static/media/banner-background-features-mobile.4e61b739.png";